import { custom } from '@carboledger/ui';
import { getTranslation } from '@/lib/utils/i18n';
import { referenceIdNumberRule, positiveNumberRule } from '@/lib/validation';

// Rules for <OutgoingShipmentForm>. `required` is declared on each <Field>, so these cover format only.
export const outgoingShipmentValidation = {
  // The server owns uniqueness of the joined shipment number.
  idNumber: referenceIdNumberRule,

  shipmentQuantity: positiveNumberRule,
};

// Only a unit the material can convert: Working needs a conversion factor set in Account setup.
export const buildShipmentUnitRules = (allowedUnits) => [
  custom(
    (value) => !value || allowedUnits.includes(value),
    getTranslation('OUTGOING_SHIPMENTS_WORKING_UNIT_NO_CORRELATION'),
  ),
];

/**
 * Props:
 *   minQuantity the assigned total, already in the unit currently selected
 *   unit        that unit's symbol, for the message
 */
export const buildShipmentQuantityRules = (minQuantity, unit) => {
  if (!minQuantity) return outgoingShipmentValidation.shipmentQuantity;

  return [
    ...outgoingShipmentValidation.shipmentQuantity,
    custom(
      (value) => Number(value) >= minQuantity,
      getTranslation('OUTGOING_SHIPMENTS_QUANTITY_BELOW_ASSIGNED', {
        quantity: minQuantity,
        unit: unit ?? '',
      }),
    ),
  ];
};
